import {combineReducers} from 'redux';
import main from './main';
import order from './order'

const rootReducer = combineReducers({
    main,
    order
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js